import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          // A client-side or network error occurred. It might be a CORS issue.
          console.error("An error occurred:", error.error);
          console.error("A network error occurred. This might be due to CORS issues.");
          return throwError(() => new Error("A network error occurred. This might be due to CORS issues."));
        }
        return throwError(() => error)
      }));
  }
}
